import { IDeviceDetectorService } from '../../src/typings/services';
import { DeviceDetectorService as NgxDeviceDetectorService } from 'ngx-device-detector';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn:'root'
})
export class CommonDeviceDetectorService implements IDeviceDetectorService {
    public static $name = 'clDeviceDetectorService';

    constructor(
        private deviceDetector: NgxDeviceDetectorService
    ) {
    }

    /**
     * Determine if we are using an Apple iOS device -- iPad, iPhone
     */
    get isIOS(): boolean {
        return this.deviceDetector.os.toLowerCase() === 'ios';
    }
}
